import { LayoutRouter } from '@/Layout'
import RouteView from '@/Layout/RouteView.vue'
// import TestPage from '@/views/TestPage.vue'

/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [
  {
    path: '/',
    component: LayoutRouter,
    redirect: '/home',
    hidden: true,
    children: [
      {
        path: '/home',
        name: 'home',
        component: () => import('@/views/HomeIndex/HomeIndex.vue'),
        mate: { title: '首页' }
      },
      {
        path: '/solution',
        name: 'solution',
        redirect: '/solution/1',
        component: RouteView,
        mate: { title: '解决方案' },
        children: [
          {
            path: '/solution/:id',
            name: 'solutionDetail',
            component: () =>
              import('@/views/SolutionDetail/SolutionDetail.vue'),
            mate: { title: '解决方案详情' },
            hidden: true
          }
        ]
      },
      {
        path: '/product',
        name: 'product',
        redirect: '/product/1',
        component: RouteView,
        mate: { title: '核心产品' },
        children: [
          {
            path: '/product/:id',
            name: 'productDetail',
            component: () => import('@/views/ProductDetail/ProductDetail.vue'),
            mate: { title: '核心产品详情' },
            hidden: true
          }
        ]
      },
      {
        path: '/customerCase',
        name: 'customerCase',
        component: () => import('@/views/CustomerCase/CustomerCase.vue'),
        mate: { title: '客户案例' }
      },
      {
        path: '/service',
        name: 'servicePage',
        component: () => import('@/views/ServicePage/ServicePage.vue'),
        mate: { title: '服务支持' }
      },
      {
        path: '/informationReported',
        name: 'informationReported',
        component: () =>
          import('@/views/InformationReported/InformationReported.vue'),
        mate: { title: '资讯报道' }
      },
      {
        path: '/attractTalents',
        name: 'attractTalents',
        component: () => import('@/views/AttractTalents/AttractTalents.vue'),
        mate: { title: '招贤纳士' }
      },
      {
        path: '/aboutUs',
        name: 'aboutUs',
        component: () => import('@/views/AboutPage/AboutPage.vue'),
        mate: { title: '关于科度' }
      }
    ]
  },
  // {
  //   path: '/ceshi',
  //   name: 'ceshi',
  //   component: TestPage
  // },
  {
    path: '',
    redirect: '/',
    hidden: true
  },
  {
    path: '*',
    redirect: '/',
    hidden: true
  }
]
